import type { Settlement, SettlementInventory } from '../types';
import { recordConsumed, removeInventory } from './inventoryManager';

export function canAffordCost(settlement: Settlement, cost: Record<string, number>): boolean {
    return Object.entries(cost).every(([key, amount]) => {
        if (key === 'tools') {
            return settlement.inventory.tools.length >= amount;
        }
        const available = settlement.inventory[key as keyof SettlementInventory] ?? 0;
        return available >= amount;
    });
}

export function applyCost(settlement: Settlement, cost: Record<string, number>): void {
    Object.entries(cost).forEach(([key, amount]) => {
        if (key === 'tools') {
            const removed = Math.min(amount, settlement.inventory.tools.length);
            settlement.inventory.tools.splice(0, removed);
            recordConsumed(settlement, 'tools', removed);
            return;
        }
        removeInventory(settlement, key as keyof Omit<SettlementInventory, 'tools'>, amount);
    });
}

export function formatCost(cost: Record<string, number>): string {
    return Object.entries(cost)
        .map(([key, amount]) => `${key} ${amount}`)
        .join(', ');
}
